export const uppercaseOnlyFirstLetter = (
  text: string,
  maxTextLength?: number
): string => {
  if (!text) return '';

  let aux = text.toLowerCase().split(' ');
  aux = aux.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  text = aux.join(' ');

  if (maxTextLength && text.length > maxTextLength) {
    text = textEllipsis(text, maxTextLength);
  }

  return text;
};

export const textEllipsis = (text: string, maxTextLength: number): string => {
  return text.length > maxTextLength
    ? `${text.substring(0, maxTextLength)}...`
    : text;
};

export const makeid = (length: number): string => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const camelize = (word: string) => {
  return word
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};

export const cnpjMask = (cnpj: string): string => {
  cnpj = cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (cnpj.length > 14) {
    cnpj = cnpj.slice(0, 14);
  }
  cnpj = cnpj.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2');
  cnpj = cnpj.replace(/^([A-Z0-9]{2}\.[A-Z0-9]{3})([A-Z0-9])/, '$1.$2');
  cnpj = cnpj.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2');
  cnpj = cnpj.replace(/([A-Z0-9]{4})([A-Z0-9])/, '$1-$2');
  return cnpj;
};

export const phoneMask = (phone?: string): string => {
  if (!phone) {
    return '-';
  }
  phone = phone.replace(/\D/g, ''); //Remove tudo o que não é dígito
  phone = phone
    .padStart(11, '0')
    .replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3'); //Formata para (99)99999-9999
  return phone;
};

export const cpfMask = (cpf: string): string => {
  cpf = cpf.replace(/\D/g, ''); //Remove tudo o que não é dígito
  cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4'); //Formata para 999.999.999-99
  return cpf;
};

export const bornDateMask = (bornDate: string): string => {
  bornDate = bornDate.replace(/\D/g, ''); //Remove tudo o que não é dígito
  bornDate = bornDate.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3'); //Formata para 00/00/0000
  return bornDate;
};

export const removeSpecialCharacters = (text: string) => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const formatTaggingString = (text: string) => {
  const result = removeSpecialCharacters(text.toLowerCase())
    .trim()
    .replace(/ /g, '_');
  return result ? result : 'not_set';
};

export const capitalizeWords = (text = '') => {
  return text
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatAddress = (data: string[]): string => {
  if (!data) {
    return '';
  }

  const addressParts = data.map(capitalizeWords).filter(Boolean).join(' - ');
  return addressParts;
};

export const internalUserEmailValidate = (email: string): boolean => {
  const regex = /@(?:[\w.-]+\.)?gerdau\.com(?:\.br)?$/i;
  return regex.test(email);
};

export const handleCopyAndEmail = async () => {
  const emailAddress = 'suportegerdaumais@gerdau.com.br';
  const subjectMail = 'Erro Inesperado - GerdauMais';

  try {
    await navigator.clipboard.writeText(emailAddress);

    window.location.href = `mailto:${emailAddress}?subject=${encodeURIComponent(
      subjectMail
    )}`;
  } catch (err) {
    console.error('Falha ao copiar support email: ', err);
  }
};
